import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import {
  IDataResponse, Registration,
} from '../interfaces';
import { FormControl, Validators, ValidatorFn } from '@angular/forms';

@Injectable()
export class FormsService {

  constructor(private _http: HttpClient) { }

  public GetRegistrationForm(eventKey: string, languageCode: string): Observable<Registration.Form.IForm> {
    return this._http.get<Registration.Form.IForm>('/api/registration/v1/form/registrationform?eventKey='
      + eventKey + '&languageCode=' + languageCode);
  }

  public GetRegistrationFormRegistrar(eventKey: string, languageCode: string): Observable<Registration.Form.IForm> {
    return this._http.get<Registration.Form.IForm>('/api/registration/v1/form/registrationformregistrar?eventKey='
      + eventKey + '&languageCode=' + languageCode);
  }

  public CreateFromControl(element: Registration.Form.IElement): FormControl {
    const validators: ValidatorFn[] = [];

    element.attributes.forEach(attr => {
      switch (attr.name) {
        case 'required':
          if (element.inputType === 'checkbox') {
            validators.push(Validators.requiredTrue);
          } else {
            validators.push(Validators.required);
          }
          break;
        case 'maxlength':
          validators.push(Validators.maxLength(attr.value));
          break;
        case 'minlength':
          validators.push(Validators.minLength(attr.value));
          break;
      }
    });

    return new FormControl(element.value, validators);
  }

  public SubmitRegistrationForm(eventKey: string, form: Registration.Form.IValues): Observable<IDataResponse> {
      console.log('submitting form 1...');
      console.log(form.emailAddress);
      console.log(form.values.length);
      console.log(form.values);
      console.log(form.id);
      console.log(form.languageCode);
    return this._http.post<IDataResponse>('/api/registration/v1/form?eventKey=' + eventKey, form);
  }
}
